// extracted by mini-css-extract-plugin
export default {"uploadPhoto":"UpdateUserAvatar_uploadPhoto__VGYa+","input":"UpdateUserAvatar_input__c61wU"};